import * as actions from 'actions/importMessages';

export const importMessagesDefaultState = {
  loading: true,
  error: false,
  data: {},
};

export default function importJobProblemsCount(
  state = importMessagesDefaultState,
  action,
) {
  switch (action.type) {
    // Overall count (used by UI that needs that):
    case actions.LOAD_IMPORT_PROBLEMS_COUNT: {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case actions.LOAD_IMPORT_PROBLEMS_COUNT_FAIL: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case actions.LOAD_IMPORT_PROBLEMS_COUNT_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        total: action.payload.total,
      };
    }
    // count for messageLevel=ERROR specifically:
    case actions.LOAD_IMPORT_ERROR_COUNT_SUCCESS: {
      return {
        ...state,
        totalErrorCount: action.payload.total,
      };
    }
    // count for messageLevel=WARN specifically:
    case actions.LOAD_IMPORT_WARNING_COUNT_SUCCESS: {
      return {
        ...state,
        totalWarningCount: action.payload.total,
      };
    }
    default:
      return state;
  }
}
